import { render, staticRenderFns } from "./SaveAndContinue.vue?vue&type=template&id=4da87171&scoped=true"
import script from "./SaveAndContinue.vue?vue&type=script&lang=js"
export * from "./SaveAndContinue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da87171",
  null
  
)

export default component.exports